import { Card, Row, Col } from "react-bootstrap";
import { FaCircle, FaUserFriends, FaUserTie } from "react-icons/fa";

const HeaderInfo = () => {
  return (
    <Card className="custom-card mb-3 border-0 shadow-sm">
      <Card.Body>

        {/* Top Section */}
        <div className="d-flex align-items-center gap-3 flex-wrap">
          <div className="icon-circle">
            <img
              src="/assets/img/social/project-01.svg"
              alt=""
              width="28"
            />
          </div>

          <div>
            <h6 className="mb-1 fw-semibold">Hospital Administration</h6>
            <p className="mb-0 small text-muted">
              Project ID : <span className="text-orange">PRO-0004</span>
            </p>
          </div>
        </div>

        {/* Status */}
        <div className="d-flex align-items-center gap-3 mt-3 flex-wrap">
          <span className="label">Status</span>
          <span className="status-pill">
            <FaCircle className="dot" /> InProgress
          </span>
        </div>

        {/* Team */}
        <div className="d-flex align-items-center gap-3 mt-3 flex-wrap">
          <span className="label">
            <FaUserFriends className="me-1" /> Team
          </span>

          <div className="d-flex flex-wrap gap-2">
            {["Lewis", "Leona", "Piniero", "Moseley"].map((name, i) => (
              <div key={i} className="user-pill">
                <img
                  src={`/assets/img/profiles/avatar-0${i + 2}.jpg`}
                  alt=""
                />
                {name}
              </div>
            ))}
            <span className="add-new">+ Add New</span>
          </div>
        </div>

        {/* Team Lead */}
        <div className="d-flex align-items-center gap-3 mt-3 flex-wrap">
          <span className="label">
            <FaUserTie className="me-1" /> Team Lead
          </span>

          <div className="d-flex flex-wrap gap-2">
            <div className="user-pill">
              <img src="/assets/img/profiles/avatar-06.jpg" alt="" />
              Ruth
            </div>
            <div className="user-pill">
              <img src="/assets/img/profiles/avatar-07.jpg" alt="" />
              Meredith
            </div>
            <span className="add-new">+ Add New</span>
          </div>
        </div>

        {/* Project Manager */}
        <div className="d-flex align-items-center gap-3 mt-3 flex-wrap">
          <span className="label">Project Manager</span>

          <div className="d-flex flex-wrap gap-2">
            <div className="user-pill">
              <img src="/assets/img/profiles/avatar-08.jpg" alt="" />
              Dwight
            </div>
            <span className="add-new">+ Add New</span>
          </div>
        </div>

        {/* Tags */}
        <div className="d-flex align-items-center gap-3 mt-3 flex-wrap">
          <span className="label">Tags</span>

          <div className="d-flex gap-2 flex-wrap">
            <span className="tag pink">Admin Panel</span>
            <span className="tag blue">High Tech</span>
          </div>
        </div>

        {/* Description */}
        <div className="mt-3">
          <h6 className="fw-semibold">Description</h6>
          <p className="text-muted small">
            The Enhanced Patient Management System (EPMS) project aims to modernize
            and streamline patient management processes. It improves patient care,
            operational efficiency, and ensures compliance with standards.
          </p>
        </div>

        {/* Footer */}
        <div className="time-box mt-3 d-flex justify-content-between align-items-center flex-wrap">
          <span>Time Spent on this project</span>
          <strong>65/120 Hrs</strong>
        </div>

      </Card.Body>
      <style>
          {
               `
               .custom-card {
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
}

.icon-circle {
  width: 50px;
  height: 50px;
  background: #eef0ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-orange {
  color: #ff6b2c;
  font-weight: 600;
}

.label {
  min-width: 130px;
  font-size: 14px;
  color: #6c757d;
}

/* Status */
.status-pill {
  background: #f3e8ff;
  color: #a855f7;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-pill .dot {
  font-size: 8px;
}

/* User pills */
.user-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f5f6f8;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 12px;
}

.user-pill img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.add-new {
  font-size: 12px;
  color: #0d6efd;
  cursor: pointer;
}

/* Tags */
.tag {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  color: white;
}

.tag.pink {
  background: #ff4d8d;
}

.tag.blue {
  background: #0d6efd;
}

/* Footer */
.time-box {
  background: #a5bac5;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
}

/* Responsive */
@media (max-width: 768px) {
  .label {
    min-width: 100%;
  }

  .time-box {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
}`
          }
      </style>
    </Card>
  );
};

export default HeaderInfo;